/*
 * Copyright (c) 2021 LucidResolutions LLC. All rights reserved.
 */


import APIBaseService from "./api.base.service";
import {MempoolService, TestnetMempoolService} from "./mempool.service";
import {is} from "@amcharts/amcharts4/core";

const testSVC = new TestnetMempoolService()
const mainSVC = new MempoolService()

const url = "/v1/defend"
class DefenderService extends APIBaseService{
    constructor() {
        super();
        this.usePathPrefix(url)
    }

    async validateTransaction(transaction: any, isTestNet: boolean){
        let input: any = transaction?.inputs?.[0]
        if(!input){
            return false
        }
        let svc = mainSVC
        if(isTestNet){
            svc = testSVC
        }

        return svc.hasValidUTXO(input.id, input.index)
    }

    async testNet(transaction: any) {
        let result = await this.request(
            this.post('/test-net', {
                transaction: transaction
            }),
            204
        )

        return result.data
    }

    async mainNet(transaction: any) {
        let result = await this.request(
            this.post('/main-net', {
                transaction: transaction
            }),
            204
        )

        return result.data
    }

    async listTransactions(){
        let result = await this.request(
            this.get('/transactions'),
            200
        )

        return result.data
    }

    async deleteTransaction(transactionID: any, isTestNet: any) {
        await this.request(
            this.delete(`/transactions/${transactionID}?is_test_net=${isTestNet}`),
            204
        )
    }

    async bumpTransaction(originalTx: any, transaction: any) {
        let result = await this.request(
            this.post(`/transactions/${originalTx.id}/bumps`, {
                transaction: transaction,
                is_test_net: originalTx.is_test_net,
            }),
            204
        )

        return result.data
    }
}


export {DefenderService}
